/* eslint
    dot-notation: "off",
    prefer-template: "warn",
    @typescript-eslint/no-use-before-define: "warn",
    block-scoped-var: "warn",
    no-redeclare: "warn",
    @typescript-eslint/no-shadow: "warn",
    no-unused-expressions: "warn",
    no-inner-declarations: "warn",
    no-else-return: "warn",
*/

import { EasyfyEventData } from '@shared/easyfy.events/easyfy.eventdata';

declare let process: {
  env: {
    NODE_ENV: string;
  };
};

export module EasyfyEventLogger {
  const topParagraphStyle: string = "line-height:6px; border-radius: 5px; width: fit-content;";
  const paragraphStyle: string = "line-height:6px; padding:6px; border-radius: 5px; width: fit-content;";


  export function ConsoleLog(message: string, prefix?: string, color?: string, bgColor?: string) {
    if (process.env.NODE_ENV === "development") {
      if (color == undefined) {
        color = '#ffffff';
      }

      let style = `color: ${color};`;

      if (bgColor) {
        style += `background: ${bgColor};`;
      }

      console.log(`%c ${prefix}${message}`, style);
    }
  }

  export function Log(this: any, obj): void {
    if (process.env.NODE_ENV === "development") {
      try {
        const haveInjectedCss = window["injectedCss"];
        if (!haveInjectedCss) {
          window["injectedCss"] = true;
          const injectedCss = window.document.styleSheets[0];
          injectedCss.insertRule(`
          @keyframes messageFlash {
          0%   { background-color: rgba(255, 255, 255, 0);}
          50%  { background-color: rgba(255, 255, 255, 0.5);}
          100% { background-color: rgba(255, 255, 255, 0);}
          }
          `, injectedCss.cssRules.length);

          injectedCss.insertRule(`.flash{
            animation: messageFlash 0.2s 2;
          }`, injectedCss.cssRules.length);

          injectedCss.insertRule(`
          @keyframes impressionBorder {
          0% { border: 0px solid #ff7600; }
          100% { border: 8px solid #ff7600; }
          }
          `, injectedCss.cssRules.length);

          injectedCss.insertRule(`.impressionSeen{
            animation: impressionBorder 0.8s 1;
            border: 8px solid #ff7600;
          }`, injectedCss.cssRules.length);
        }
      }
      catch (error) {
        console.warn(error);
      }

      const devEventLogButton = document.querySelector("#devEventLogButton");
      if (!devEventLogButton) {
        const logButtonElem = document.createElement('div');
        logButtonElem.id = "devEventLogButton";
        logButtonElem.style.position = "fixed";
        logButtonElem.style.cursor = "pointer";
        logButtonElem.style.bottom = "5px";
        logButtonElem.style.left = "5px";
        logButtonElem.style.width = "10px";
        logButtonElem.style.height = "10px";
        logButtonElem.style.fontSize = "10px";
        logButtonElem.style.zIndex = "2147483646";

        logButtonElem.onclick = this.EnableLog;
        logButtonElem.innerHTML = "🖥️";

        document.querySelector('body').appendChild(logButtonElem);
      }

      let devEventOutput = document.querySelector("#devEventOutput");
      if (!devEventOutput) {
        const outputDiv = document.createElement('div');
        outputDiv.id = "devEventOutput";
        outputDiv.style.position = "fixed";
        outputDiv.style.backgroundColor = "#000000de";
        outputDiv.style.color = "#c4c4c4";
        outputDiv.style.zIndex = "2147483646";
        outputDiv.style.width = "100%";
        outputDiv.style.height = "200px";
        outputDiv.style.bottom = "0";
        outputDiv.style.fontSize = "10px";
        outputDiv.style.fontFamily = "Roboto, Helvetica";
        outputDiv.style.lineHeight = "4px";
        outputDiv.style.display = "grid";
        outputDiv.style.gridTemplateColumns = "120px 1fr";
        outputDiv.style.gridTemplateRows = "30px 1fr";

        const topElement = document.createElement('div');
        topElement.style.position = "sticky";
        topElement.style.top = "0px";
        topElement.style.width = "100%";
        topElement.style.height = "30px";
        topElement.style.padding = "7px 5px";
        topElement.style.color = "#73ff69";
        topElement.style.display = "flex";
        topElement.style.gridGap = "20px";
        topElement.style.gridColumn = "2";
        topElement.style.gridRow = "1";

        topElement.innerHTML = `<p style="${topParagraphStyle}">EventLayer.Services: <span id="devEventServices">No registered</span></p>
          <p style="${topParagraphStyle}">EventLayer.Products: <span id="devLayerProducts">0</span></p>
          <p style="${topParagraphStyle}">EventLayer.ProductLists: <span id="devLayerLists">0</span></p>
          <p style="${topParagraphStyle}">EventLayer.ProductPrices: <span id="devLayerPrices">0</span></p>
          <p style="${topParagraphStyle}">EventLayer.Banners: <span id="devLayerBanners">0</span></p>
          <p style="${topParagraphStyle}">Product impressions: <span id="devProductImpressions">0</span></p>`;

        const leftElement = document.createElement('div');
        leftElement.style.width = "120px;";
        leftElement.style.height = "30px";
        leftElement.style.gridColumn = "1";
        leftElement.style.gridRow = "1";
        leftElement.style.display = "flex";

        const iconParagraph1 = document.createElement('p');
        iconParagraph1.style.cursor = "pointer";
        iconParagraph1.style.width = "30px";
        iconParagraph1.style.height = "30px";
        iconParagraph1.style.padding = "0px 6px";
        iconParagraph1.style.lineHeight = "30px";
        iconParagraph1.onclick = EasyfyEventLogger.DisableLog;
        iconParagraph1.innerHTML = "🖥️";

        leftElement.appendChild(iconParagraph1);

        const iconParagraph2 = document.createElement('p');
        iconParagraph2.style.cursor = "pointer";
        iconParagraph2.style.width = "30px";
        iconParagraph2.style.height = "30px";
        iconParagraph2.style.padding = "0px 6px";
        iconParagraph2.style.lineHeight = "30px";
        iconParagraph2.onclick = EasyfyEventLogger.PrintEventLayer;
        iconParagraph2.innerHTML = "📄";

        leftElement.appendChild(iconParagraph2);

        const iconParagraph3 = document.createElement('p');
        iconParagraph3.style.cursor = "pointer";
        iconParagraph3.style.width = "30px";
        iconParagraph3.style.height = "30px";
        iconParagraph3.style.padding = "0px 8px";
        iconParagraph3.style.lineHeight = "30px";
        iconParagraph3.style.transform = "scale(1.6)";

        if (ImpressionVisualizerIsOn()) {
          iconParagraph3.style.color = "#ff7600";
        } else {
          iconParagraph3.style.color = "#c4c4c4";
        }

        iconParagraph3.id = "toggleImpressionBtn";
        iconParagraph3.onclick = EasyfyEventLogger.ToggleImpressionVisualizer;
        iconParagraph3.innerHTML = "👁";

        leftElement.appendChild(iconParagraph3);


        const textElement = document.createElement('div');
        textElement.id = "outputText";
        textElement.style.padding = "5px";
        textElement.style.overflowY = "scroll";
        textElement.style.height = "170px";
        textElement.style.gridColumn = "2";
        textElement.style.gridRow = "2";
        textElement.style.borderRadius = "5px";

        outputDiv.appendChild(topElement);
        outputDiv.appendChild(leftElement);
        outputDiv.appendChild(textElement);
        document.querySelector('body').appendChild(outputDiv);

        this.CheckLogStatus();
      }

      devEventOutput = document.querySelector("#devEventOutput");
      if (!devEventOutput) return;

      if (obj.type === "productimpression") {
        const textOutput = devEventOutput.querySelector('#outputText');
        textOutput.innerHTML += `<p style='${paragraphStyle}'>${obj.message}</p>`;
        const productImpressions = Number.parseInt(devEventOutput.querySelector('#devProductImpressions').innerHTML, 10);
        devEventOutput.querySelector('#devProductImpressions').innerHTML = (productImpressions + 1).toString();

        textOutput.scrollTop = textOutput.scrollHeight;

        if (obj.target && ImpressionVisualizerIsOn()) {
          (obj.target as HTMLElement).classList.add("impressionSeen");
        }
      }
      else if (obj.type === "servicesregistered") {
        devEventOutput.querySelector('#devEventServices').innerHTML = obj.message;
      }
      else if (obj.type === "updateeventlayerstatus") {
        const lists = EasyfyEventData.AllProductLists();
        const products = EasyfyEventData.AllProducts();
        const banners = EasyfyEventData.AllBanners();
        const prices = EasyfyEventData.AllProductSalesUnitPrices();

        const eventLayerProductsCount = Object.keys(products).length;
        const eventLayerProductListsCount = Object.keys(lists).length;
        const eventLayerBannersCount = Object.keys(banners).length;
        const eventLayerPricesCount = Object.keys(prices).length;


        devEventOutput.querySelector('#devLayerLists').innerHTML = eventLayerProductListsCount.toString();
        devEventOutput.querySelector('#devLayerProducts').innerHTML = eventLayerProductsCount.toString();
        devEventOutput.querySelector('#devEventServices').innerHTML = EasyfyEventData.GetServiceNames().join(", ");
        devEventOutput.querySelector('#devLayerBanners').innerHTML = eventLayerBannersCount.toString();
        devEventOutput.querySelector('#devLayerPrices').innerHTML = eventLayerPricesCount.toString();

      }
      else if (obj.type === "event") {
        const textOutput = devEventOutput.querySelector('#outputText');
        textOutput.className = "";
        textOutput.innerHTML += `<p style='color: #6ad6ff;${paragraphStyle}'>${obj.message}</p>`;
        textOutput.scrollTop = textOutput.scrollHeight;
        setTimeout(() => {
          const textOutput = devEventOutput.querySelector('#outputText');
          textOutput.className = "flash";
        }, 20);
      }
      else if (obj.type === "warning") {
        const textOutput = devEventOutput.querySelector('#outputText');
        textOutput.innerHTML += `<p style='color: #ffd76a;${paragraphStyle}'>${obj.message}</p>`;
        textOutput.scrollTop = textOutput.scrollHeight;
      }
      else if (obj.type === "error") {
        const textOutput = devEventOutput.querySelector('#outputText');
        textOutput.innerHTML += `<p style='color: #ff6a6a;${paragraphStyle}'>${obj.message}</p>`;
        textOutput.scrollTop = textOutput.scrollHeight;
      }
      else {
        const textOutput = devEventOutput.querySelector('#outputText');
        textOutput.innerHTML += `<p style='${paragraphStyle}'>${obj.message}</p>`;
        textOutput.scrollTop = textOutput.scrollHeight;
      }
    }
  }

  export function CheckLogStatus(this: any): void {
    if (process.env.NODE_ENV === "development") {
      const useEventLog = localStorage.getItem("easyfyDevEventLog") === "true";

      useEventLog ? this.EnableLog() : this.DisableLog();
    }
  }

  export function EnableLog(): void {
    if (process.env.NODE_ENV === "development") {
      localStorage.setItem("easyfyDevEventLog", "true");
      const devEventOutput = document.querySelector("#devEventOutput") as HTMLElement;
      if (devEventOutput) {
        devEventOutput.style.display = "grid";
      }
    }
  }

  export function DisableLog(): void {
    if (process.env.NODE_ENV === "development") {
      localStorage.setItem("easyfyDevEventLog", "false");
      const devEventOutput = document.querySelector("#devEventOutput") as HTMLElement;
      if (devEventOutput) {
        devEventOutput.style.display = "none";
      }
    }
  }

  export function ToggleImpressionVisualizer(): void {
    if (process.env.NODE_ENV === "development") {
      const date = new Date();
      date.setDate(date.getDate() + 30);
      const visualizerValue = localStorage.getItem("easyfyDevImpVisualizer");
      const btn = document.querySelector("#toggleImpressionBtn") as HTMLElement;

      if (visualizerValue === "true") {
        localStorage.setItem("easyfyDevImpVisualizer", "false");
        btn.style.color = "#c4c4c4";

        document.querySelectorAll('.impressionSeen').forEach((elem) => {
          elem.classList.remove('impressionSeen');
        });
      }
      else {
        localStorage.setItem("easyfyDevImpVisualizer", "true");
        btn.style.color = "#ff7600";
        document.querySelectorAll('[data-track-product][data-track-impression="True"]').forEach((elem) => {
          elem.classList.add('impressionSeen');
        });
      }
    }
  }

  function ImpressionVisualizerIsOn(): boolean {
    const visualizerValue = localStorage.getItem("easyfyDevImpVisualizer");
    if (visualizerValue === "true") {
      return true;
    }

    return false;

  }

  export function PrintEventLayer(): void {
    if (process.env.NODE_ENV === "development") {

      let devEventLayerOutput = document.querySelector("#devEventLayerOutput") as HTMLDivElement;
      if (!devEventLayerOutput) {
        const outputDiv = document.createElement('div');
        outputDiv.id = "devEventLayerOutput";
        outputDiv.style.position = "fixed";
        outputDiv.style.height = "66%";
        outputDiv.style.width = "70%";
        outputDiv.style.top = "100px";
        outputDiv.style.left = "15%";
        outputDiv.style.backgroundColor = "#000000de";
        outputDiv.style.color = "#c4c4c4";
        outputDiv.style.zIndex = "2147483647";
        outputDiv.style.borderRadius = "5px";
        outputDiv.style.boxShadow = "1px 0px 14px 1px rgba(0,0,0,0.3)";
        outputDiv.style.fontSize = "11px";
        outputDiv.style.overflow = "auto";

        const iconParagraph = document.createElement('p');
        iconParagraph.style.cursor = "pointer";
        iconParagraph.style.width = "30px";
        iconParagraph.style.height = "30px";
        iconParagraph.style.padding = "0px 8px";
        iconParagraph.style.lineHeight = "30px";
        iconParagraph.style.position = "fixed";
        iconParagraph.onclick = EasyfyEventLogger.HidePrintedEventLayer;
        iconParagraph.innerHTML = "✖";

        const textElement = document.createElement('div');
        textElement.id = "devEventLayerOutputText";
        textElement.style.padding = "30px";
        textElement.style.fontFamily = "monospace";
        textElement.style.whiteSpace = "pre";

        outputDiv.appendChild(iconParagraph);
        outputDiv.appendChild(textElement);


        document.querySelector('body').appendChild(outputDiv);
        devEventLayerOutput = document.querySelector("#devEventLayerOutput") as HTMLDivElement;

      }

      devEventLayerOutput.style.display = "block";
      const brace = {
        brace: 0
      };

      const jsonstring = JSON.stringify(window.EasyfyEventLayer, null, 2);
      const outputElement = document.querySelector("#devEventLayerOutputText") as HTMLDivElement;
      outputElement.innerHTML = `<h4>Event layer:</h4>${jsonstring}`;
      // console.log(JSON.stringify(window.EasyfyEventLayer, null, 2));
    }
  }

  export function HidePrintedEventLayer(): void {
    if (process.env.NODE_ENV === "development") {
      const devEventLayerOutput = document.querySelector("#devEventLayerOutput") as HTMLDivElement;
      if (devEventLayerOutput) {
        devEventLayerOutput.style.display = "none";
      }
    }
  }
}
